import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { AuthenticationService } from "src/app/services/authentication.service";
import { Router, ActivatedRoute } from "@angular/router";
import { ProductService } from "src/app/services/product.service";
import { NotificationService } from "src/app/services/notification.service";
import { Alert, BaseResponse } from "src/app/models/base-response";
import {
  Notification,
  NotificationConstantType,
} from "src/app/models/notification";
import { CartService } from "src/app/services/cart.service";
import { Cart } from "src/app/models/cart";
import { Observable, of } from "rxjs";
import {
  debounceTime,
  distinctUntilChanged,
  tap,
  switchMap,
  catchError,
  map,
} from "rxjs/operators";
import { Limit } from "src/app/models/account";
import { UserTransaction } from "src/app/models/receivable";
import { PointService } from "src/app/services/point.service";
import { SurveyService } from "src/app/services/survey.service";
import * as firebase from "firebase";

@Component({
  selector: "app-admin-header",
  templateUrl: "./admin-header.component.html",
  styleUrls: ["./admin-header.component.css"],
})
export class AdminHeaderComponent implements OnInit {
  userProfile = null;
  public initial = "";
  countNotif: number = 0;
  countItem: number;
  searching = false;
  searchFailed = false;
  notifs: Notification[] = [];
  transaction: UserTransaction = new UserTransaction();
  Carts: Cart[] = [];
  limit: Limit;
  point: "0";
  @Input() keywordSearchText: string = "";
  @Output() OnKeywordChanged: EventEmitter<string> = new EventEmitter<string>();
  @Output() refreshNotif: EventEmitter<any> = new EventEmitter<any>();

  alertNotifs: Alert;
  alertCountNotifs: Alert;
  isProgramRouter = false;

  constructor(
    private router: Router,
    private authService: AuthenticationService,
    private notifService: NotificationService,
    public productService: ProductService,
    private cartService: CartService,
    private pointService: PointService,
    private surveyService: SurveyService,
    private route: ActivatedRoute
  ) {
  }

  ngOnInit() {
    this.userProfile = this.authService.getObjUserProfile();
    const matches = this.userProfile.fullname.match(/\b(\w)/g);
    this.initial = matches.join("").substring(0, 2);
    const programId = this.route.snapshot.paramMap.get("id");

    this.loadNotificationCount();
    this.loadNotification();
    this.loadCart();
    this.loadLimit();
    this.loadPoint();

    if (
      this.router.url == "/program" ||
      this.router.url == "/program/detail/" + programId
    ) {
      this.isProgramRouter = true;
    }
  }

  loadNotificationCount() {
    this.notifService.getCountNotification(
      (resp) => {
        this.alertCountNotifs = resp.alert;
        if (resp.alert.code == 200) {
          this.countNotif = resp.data;
        }
      },
      (err) => {
        console.log('err: ', err);
      }
    );
  }

  loadNotification() {
    this.notifService.getListNotification(
      10,
      0,
      (resp) => {
        this.alertNotifs = resp.alert;
        if (resp.alert.code == 200) {
          // resp.data.forEach(item => {
          //   const createdDate = new Date(item.created_date);
          //   createdDate.setHours(createdDate.getHours() + 7);
          //   item.created_date = createdDate;

          //   item.string_created_date = this.notifService.getDiffTimeString(item.created_date);
          // });
          this.notifs = resp.data;
        }
      },
      (err) => { }
    );
  }

  loadLimit() {
    this.authService.getLimit(
      (resp) => {
        if (resp.alert.code === 200) {
          this.limit = resp.data;
          this.limit.limit = resp.data.limit
            .toString()
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        } else {
          console.log(resp);
        }
      },
      (err) => {
        console.log(err);
      }
    );
  }

  loadPoint(): void {
    this.pointService.getPoint(
      (data) => {
        this.point = data.point;
      },
      (err) => {
        console.log(err);
      }
    );
  }

  action(data: Notification) {
    firebase.analytics().logEvent("notification_page");

    this.notifService.putNotification(
      data.id,
      (resp) => {
        this.loadNotification();
        this.loadNotificationCount();
        this.refreshNotif.emit();

        const notificationData = JSON.parse(data.data);
        if (
          notificationData.NotificationConstant ===
          NotificationConstantType.NewInformation
        ) {
          this.router.navigate(["/detail-promo/" + notificationData.ContextId]);
        } else if (
          notificationData.NotificationConstant ===
          NotificationConstantType.PaymentInformation
        ) {
          this.transaction.id = notificationData.ContextId;
          this.router.navigate([
            `/receivable/detail-payment/${btoa(
              JSON.stringify(this.transaction)
            )}`,
          ]);
        } else if (
          notificationData.NotificationConstant ===
          NotificationConstantType.ChangeLimit
        ) {
          this.router.navigate(["/security/change-limit"]);
        } else if (
          notificationData.NotificationConstant ===
          NotificationConstantType.Survey
        ) {
          this.surveyService.showSurvey(notificationData.ContextId);
        } else if (
          notificationData.NotificationConstant ===
          NotificationConstantType.Order
        ) {
          localStorage.setItem("transactionId", notificationData.ContextId);
          this.router.navigate(["/transaction/"]);
        } else if (
          notificationData.NotificationConstant ===
          NotificationConstantType.OpenProposalSuccess
        ) {
          this.router.navigate([`/proposal/detail/${notificationData.ContextId}`]);
        }
      },
      (err) => { }
    );
  }

  searchHistory = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      tap(() => (this.searching = true)),
      switchMap((term) =>
        this.productService.get("/product/search_history").pipe(
          tap(() => (this.searchFailed = false)),
          catchError(() => {
            this.searchFailed = true;
            return of([]);
          })
        )
      ),
      tap<BaseResponse>(() => (this.searching = false)),
      map((data) => {
        const item = [];
        data.data.forEach((element) => {
          item.push(element.name);
        });

        return item;
      })
    );

  loadCart(): void {
    this.cartService.getCart(
      (data) => {
        if (data !== undefined || data !== null) {
          this.setCarts(data);
        }
      },
      (err) => { }
    );
  }

  onSelectedItem(textValue: any): void {
    this.keywordSearchText = textValue.item;
    this.navigateToProductPage();
  }

  onEnter(): void {
    firebase.analytics().logEvent("product_search_button");

    this.navigateToProductPage();
  }

  navigateToProductPage(): void {
    this.OnKeywordChanged.emit(this.keywordSearchText);
    this.router.navigate(["/product"], {
      queryParams: { keyword: this.keywordSearchText },
    });
  }

  logout() {
    firebase.analytics().logEvent("profil_logout_button");

    this.authService.logout();

    this.router.navigate(["/"]);
  }

  countProduct() {
    this.countItem = this.Carts.reduce(
      (total, item) => total + item.quantity,
      0
    );
  }
  setCarts(carts: Cart[]) {
    this.Carts = carts;
    this.countProduct();
  }
}
